// extracted by css-extract-rspack-plugin
export default {"root":"HeaderWrapperV8_root__a7-Ta","draggableHeader":"HeaderWrapperV8_draggableHeader__FHuem"};